"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const updateLastStudied_1 = __importDefault(require("../../utils/updateLastStudied"));
function updateQuizLastStudied(existingStats, session) {
    return (0, updateLastStudied_1.default)(existingStats, session.timeFinished);
}
exports.default = updateQuizLastStudied;
